import * as types from '../actions/actionTypes';

const initialState = {
    recipientSuggestions: {
        loading: false,
        success: true,
        data: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_RECIPIENT_SUGGESTIONS:
            return Object.assign({}, state, { recipientSuggestions: { ...state.recipientSuggestions, loading: true, success: true } });
        case types.GET_RECIPIENT_SUGGESTIONS:
            return Object.assign({}, state, { recipientSuggestions: action.response });
        case types.CLEAR_RECIPIENT_SUGGESTIONS:
            return Object.assign({}, state, { recipientSuggestions: initialState.recipientSuggestions });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/SuggestionsReducer.js